import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import { analyticsTrack } from '../../analyticsUtils';
import InvoicesWalkthroughSequences from './InvoicesWalkthroughSequences';
import InvoicesWalkthroughFooter from './InvoicesWalkthroughFooter';
import './InvoicesWalkthrough.scss';

class InvoicesWalkthrough extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      sequence: 0,
    };
    this.setSequence = this.setSequence.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  setSequence(sequence) {
    this.setState({
      sequence,
    });
  }

  openModal() {
    const { userType, triggerText } = this.props;
    this.setState({ showModal: true }, () => {
      analyticsTrack(`Clicked on ${triggerText}`, { location: `${userType} Invoice Index` });
    });
  }

  closeModal() {
    this.setState({
      showModal: false,
    });
  }

  render() {
    const { sequence, showModal } = this.state;
    const { userType, triggerText, isButton } = this.props;

    return (
      <Fragment>
        {
          isButton ? (
            <button
              className="btn btn-secondary"
              onClick={this.openModal}
            >
              {triggerText}
            </button>
          ) : (
            <a
              className="modal-anchor-trigger link"
              tabIndex={0}
              role="button"
              onClick={this.openModal}
            >
              {triggerText}
            </a>
          )
        }
        <Modal
          id="invoice-walkthrough"
          className="style-guide"
          show={showModal}
          onHide={this.closeModal}
          size="lg"
        >
          <Modal.Body>
            <div className="style-guide">
              <div className="walkthrough-container">
                <InvoicesWalkthroughSequences
                  type={userType}
                  sequence={sequence}
                  closeModal={this.closeModal}
                />
                <InvoicesWalkthroughFooter
                  type={userType}
                  sequence={sequence}
                  setSequence={this.setSequence}
                  closeModal={this.closeModal}
                />
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </Fragment>
    );
  }
}

InvoicesWalkthrough.propTypes = {
  userType: PropTypes.string.isRequired,
  triggerText: PropTypes.string.isRequired,
  isButton: PropTypes.bool,
};

InvoicesWalkthrough.defaultProps = {
  isButton: false,
};

export default InvoicesWalkthrough;
